import { render, staticRenderFns } from "./DeliveryFileModal.vue?vue&type=template&id=42961cb4&"
import script from "./DeliveryFileModal.vue?vue&type=script&lang=js&"
export * from "./DeliveryFileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DeliveryFileModal.vue"
export default component.exports